import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { text_field_change } from "../../redux/actions";

export const OverallVolume = () => {
    const dispatch = useDispatch();
    const placesValue = useSelector(
        (state) => state.app.fields.overallVolume.places.value,
    );
    const placesError = useSelector(
        (state) => state.app.fields.overallVolume.places.error,
    );
    const weightValue = useSelector(
        (state) => state.app.fields.overallVolume.weight.value,
    );
    const weightError = useSelector(
        (state) => state.app.fields.overallVolume.weight.error,
    );
    const volumeValue = useSelector(
        (state) => state.app.fields.overallVolume.volume.value,
    );
    const volumeError = useSelector(
        (state) => state.app.fields.overallVolume.volume.error,
    );
    return (
        <div className="front-calc__overall_volume">
            <div className="front-calc__overall_volume_col">
                <label htmlFor="overall_volume_places">
                    Кол-во <br />
                    мест
                </label>
                <input
                    type="number"
                    id="overall_volume_places"
                    className={"text-input" + (placesError ? " error" : "")}
                    name="overall_volume_places"
                    autoComplete="off"
                    placeholder="0"
                    min="0"
                    value={placesValue}
                    onChange={(e) =>
                        dispatch(
                            text_field_change(
                                "overall_volume_places",
                                e.target.value,
                                0,
                            ),
                        )
                    }
                />
            </div>
            <div className="front-calc__overall_volume_col">
                <label htmlFor="overall_volume_weight">
                    Вес, <br />
                    кг
                </label>
                <input
                    type="number"
                    id="overall_volume_weight"
                    className={"text-input" + (weightError ? " error" : "")}
                    name="overall_volume_weight"
                    autoComplete="off"
                    placeholder="0"
                    min="0"
                    value={weightValue}
                    onChange={(e) =>
                        dispatch(
                            text_field_change(
                                "overall_volume_weight",
                                e.target.value,
                                0,
                            ),
                        )
                    }
                />
            </div>
            <div className="front-calc__overall_volume_col">
                <label htmlFor="overall_volume_volume">
                    Объем, <br />
                    м3
                </label>
                <input
                    type="number"
                    id="overall_volume_volume"
                    className={"text-input" + (volumeError ? " error" : "")}
                    name="overall_volume_volume"
                    autoComplete="off"
                    placeholder="0"
                    min="0"
                    value={volumeValue}
                    onChange={(e) =>
                        dispatch(
                            text_field_change(
                                "overall_volume_volume",
                                e.target.value,
                                0,
                            ),
                        )
                    }
                />
            </div>
        </div>
    );
};
